import { BenefitIcon } from '@/components/BenefitIcon';
import { components } from '@/types/api';

export default function LineItemEnrichDetails({
  benefitTotals,
}: {
  benefitTotals: components['schemas']['ReceiptLineItemBenefit'][] | null;
}) {
  return (
    <>
      {benefitTotals &&
        benefitTotals.map((item, i) => {
          return (
            <>
              <div className="border-primary-platinum grid min-h-9 grid-cols-4 items-center gap-2 border-b border-none">
                <BenefitIcon lineItemBenefit={item} index={i} />
                <span className="text-xs"> {item.eligible ? 'eligible' : 'not eligible'}</span>
                <span className="text-xs">
                  <div className="flex flex-col">
                    <span>{item.applied ? 'covered' : 'not covered'}</span>
                    {item.eligible && !item.applied ? <span>{item.decision_reason}</span> : null}
                  </div>
                </span>
                <span className="text-right text-xs">
                  {item.applied_amount ? <>${item.applied_amount}</> : '$0'}
                </span>
              </div>
              <div className="border-background border-b"></div>
            </>
          );
        })}
    </>
  );
}
